const NotFoundConstantsAR = {
  notFoundMessage: 'الصفحة المطلوبة لا يمكن العثور عليها',
};
export default NotFoundConstantsAR;
